export default "__VITE_ASSET__Btpu_MLK__"